export default __webpack_public_path__ + "static/media/icon2.5a903e0f.svg";